import { render, staticRenderFns } from "./ConfigureDialog.vue?vue&type=template&id=45593ea8&"
import script from "./ConfigureDialog.vue?vue&type=script&lang=js&"
export * from "./ConfigureDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports